const privacySafeQuery = (value) => {
  const query = String(value || "")
    .trim()
    .replace(/\s+/g, " ")
    .slice(0, 100);
  if (!query) return "";
  if (/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i.test(query)) return "";
  if (/(?:\+?44|0)\s*\d(?:[\s()-]*\d){8,}/.test(query)) return "";
  return query;
};

const publish = (name, detail = {}) => {
  const payload = { event: name, ...detail };
  window.dispatchEvent(
    new CustomEvent(`expressdrop:${name}`, { detail: payload }),
  );
  if (typeof window.gtag === "function") {
    window.gtag("event", name, detail);
  } else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }
};

const grid = document.querySelector("[data-ed-discovery-grid]");
if (grid instanceof HTMLElement) {
  const pageType = grid.dataset.edPageType || "";
  const resultCount =
    Number.parseInt(grid.dataset.edResultCount || "0", 10) || 0;
  const query = privacySafeQuery(grid.dataset.edSearchQuery);
  const stateKey = `${location.pathname}${location.search}`;

  let previousState = "";
  try {
    previousState = sessionStorage.getItem("ed-discovery-view") || "";
  } catch {
    previousState = "";
  }

  if (previousState !== stateKey) {
    try {
      sessionStorage.setItem("ed-discovery-view", stateKey);
    } catch {}
    publish(
      pageType === "search"
        ? "ed_search_results_view"
        : "ed_collection_results_view",
      {
        result_count: resultCount,
        zero_results: resultCount === 0,
        ...(query ? { search_term: query } : {}),
      },
    );
  }
}

document.addEventListener("click", (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  const productLink = target.closest(
    '.product-grid__item a[href*="/products/"]',
  );
  if (productLink instanceof HTMLAnchorElement) {
    const item = productLink.closest(".product-grid__item");
    const siblings = item?.parentElement
      ? [...item.parentElement.children]
      : [];
    publish("ed_product_discovery_click", {
      destination: productLink.pathname,
      position: item ? siblings.indexOf(item) + 1 : 0,
      source: location.pathname.endsWith("/search") ? "search" : "collection",
    });
    return;
  }

  const recoveryLink = target.closest(
    ".ed-search-guide a, .ed-empty-collection a",
  );
  if (recoveryLink instanceof HTMLAnchorElement) {
    publish("ed_discovery_recovery_click", {
      destination: recoveryLink.pathname,
      source: recoveryLink.closest(".ed-search-guide")
        ? "search_recovery"
        : "empty_collection",
    });
  }
});

document.addEventListener("change", (event) => {
  const target = event.target;
  if (!(
    target instanceof HTMLInputElement || target instanceof HTMLSelectElement
  ))
    return;
  if (!target.closest("facets-form-component, sorting-filter-component"))
    return;

  publish(target.name === "sort_by" ? "ed_sort_change" : "ed_filter_change", {
    control: target.name || target.id || "unknown",
    value: String(target.value || "").slice(0, 100),
    source: location.pathname.endsWith("/search") ? "search" : "collection",
  });
});
